import Vue from 'vue'
import Router from 'vue-router'
import AktuelleRunde from '@/components/AktuelleRunde'
import LetzteRunden from '@/components/LetzteRunden'
import SucheRunde from '@/components/SucheRunde'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'AktuelleRunde',
      component: AktuelleRunde
    },
    {
      path: '/LetzteRunden',
      name: 'LetzteRunden',
      component: LetzteRunden
    },
    {
      path: '/SucheRunde',
      name: 'SucheRunde',
      component: SucheRunde
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js